<script setup lang="ts">
import { useParticipateInCanvass } from "@/canvasses/canvassesCrud";
import type { CanvassListItem } from "@/canvasses/types";
import ListItem from "@/components/ListItem.vue";
import CanvassListItemDetails from "./CanvassListItemDetails.vue";

const { canvassListItem } = defineProps<{
  canvassListItem: CanvassListItem;
}>();

const { participateInCanvass } = useParticipateInCanvass(canvassListItem.id);
</script>

<template>
  <ListItem>
    <template #header>
      <h3>
        {{ canvassListItem.name }}
      </h3>
    </template>
    <CanvassListItemDetails :canvass-list-item />
    <template #actions>
      <p
        v-if="canvassListItem.currentUserParticipationState === 'pending'"
        class="text-semibold"
      >
        Deine Teilnahme wurde angefragt und muss noch bestätigt werden. ⌛
      </p>
      <button
        v-else-if="canvassListItem.currentUserParticipationState === 'none'"
        class="button"
        @click="participateInCanvass()"
      >
        Teilnehmen
      </button>
      <p
        v-if="canvassListItem.currentUserParticipationState === 'participating'"
        class="text-semibold"
      >
        Du nimmst bereits teil.
      </p>
    </template>
  </ListItem>
</template>
